import React from "react";
import ThreeDotIcon from "./ThreeDotIcon.jsx";
import ActionsDropdown from "./ActionsDropdown.jsx";

/**
 * ActionsMenu Component
 * Wrapper component that combines ThreeDotIcon and ActionsDropdown
 */
const ActionsMenu = ({
  itemId,
  isOpen,
  onToggle,
  onDuplicate,
  onDelete,
  duplicateLoading,
  deleteLoading,
  deleteId,
  className = "custom-dropdown12",
  style = {},
  refCallback,
}) => {
  return (
    <div
      className={className}
      style={style}
      ref={refCallback}
    >
      <ThreeDotIcon onClick={onToggle} />
      <ActionsDropdown
        isOpen={isOpen}
        itemId={itemId}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        duplicateLoading={duplicateLoading}
        deleteLoading={deleteLoading}
        deleteId={deleteId}
      />
    </div>
  );
};

export default ActionsMenu;
